<template>
    <ModalComponent
        :name="'descuento-plazo-' + plazo_id"
        title="Descuento plazo"
        v-on:close="close"
    >
        <DescuentoComponent :importe="importe" @descontado="descontarPlazo" @close="close()"></DescuentoComponent>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

import DescuentoComponent from "./DescuentoComponent.vue";

export default {
    props: ['plazo_id', 'importe'],
    methods: {
        close() {
            this.$emit('close', 'descuento-plazo-' + this.plazo_id);
        },
        descontarPlazo(descuento_integro, descuento_porcentaje) {
            this.$emit('terminado', descuento_integro, descuento_porcentaje, this.plazo_id);
        }
    },
    components: {
        ModalComponent, DescuentoComponent
    }
}
</script>